/* APLICAR DESCUENTOS DESDE LA URL 							*/
/*
  let params = new URLSearchParams(window.location.search);let promocode = params.get('promocode'); 
if (promocode) { 
  	var urll = '/discount/' + promocode;
  	fetch(urll)  	
  	.then(data => console.log(data));  
}
*/

/****************************************************************/
/* COMPROBAR COOKIES TERMS HUB   							    */
/****************************************************************/
document.addEventListener("change", async function (event) {
  var input = event.target.closest(".product-item-meta__swatch-list .color-swatch__radio");
  if (!input) return;

  var productItem = input.closest("product-item");
  if (!productItem) return;

  var slider = productItem.querySelector(".product-item__plp-slider");
  if (!slider || !slider.flickityInstance) return;

  var featuredMediaId = input.getAttribute("data-variant-featured-media");
  if (!featuredMediaId) return;

  var targetCell = slider.querySelector('[data-media-id="' + featuredMediaId + '"]');
  if (!targetCell) return;

  var flickity = await slider.flickityInstance;
  flickity.selectCell(targetCell);
});

var conset_data = false;

function buscar_cookie() {
  var nombreTermsHub = "termshub-consent=";
  var ca = document.cookie.split(';');
  var cookie_obj = "";  
  
  for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nombreTermsHub) == 0) cookie_obj = JSON.parse(c.substring(nombreTermsHub.length,c.length));      
  }

  return cookie_obj;
}
  
function inicializar() {
  var cookie_obj = buscar_cookie();

  console.log("ENTRA");      
  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('js', new Date());
  gtag('config', 'G-D2ZGVP6PVD');    
  
  if (cookie_obj == "") {    
    console.log("NO COOKIES");      
    // Set default consent to 'denied' as a placeholder    
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });  

    gtag('consent', 'update', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });    
    
  } else if (cookie_obj.categories) {      
    var necessary_val = cookie_obj.categories.necessary.wanted ? 'granted' : 'denied';    
    var analytics_val = cookie_obj.categories.statistics.wanted ? 'granted' : 'denied';
    var functional_val = cookie_obj.categories.functional.wanted ? 'granted' : 'denied';
    var ads_val = cookie_obj.categories.marketing.wanted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      'ad_storage': ads_val,
      'ad_user_data': ads_val,
      'ad_personalization': ads_val,
      'analytics_storage': analytics_val
    });     
  }  
}

function consent_check() {
  var cookie_obj = buscar_cookie();
  
  if (cookie_obj.categories) {    
    var necessary_val = cookie_obj.categories.necessary.wanted ? 'granted' : 'denied';    
    var analytics_val = cookie_obj.categories.statistics.wanted ? 'granted' : 'denied';
    var functional_val = cookie_obj.categories.functional.wanted ? 'granted' : 'denied';
    var ads_val = cookie_obj.categories.marketing.wanted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      'ad_storage': ads_val,
      'ad_user_data': ads_val,
      'ad_personalization': ads_val,
      'analytics_storage': analytics_val
    });     
    conset_data = true;
  }  
}

// Función para verificar si se ha modificado una cookie
function verificarCambiosEnCookies(callback) {
    // Guardar una copia del estado actual de las cookies
    var cookiesAnteriores = document.cookie;

    // Establecer un intervalo de tiempo para verificar continuamente los cambios en las cookies
    setInterval(function() {
        // Obtener el estado actual de las cookies
        var cookiesActuales = document.cookie;

        // Verificar si ha habido cambios en las cookies
        if (cookiesActuales !== cookiesAnteriores) {            
            // Ejecutar la función de callback cuando se detecte un cambio
            callback();
            // Actualizar el estado de las cookies para la próxima comparación
            cookiesAnteriores = cookiesActuales;
        }
    }, 1000); // Intervalo de verificación (en milisegundos)
}

inicializar();
// Llamar a la función para verificar cambios en las cookies
verificarCambiosEnCookies(consent_check);
(function () {
  if (window.ConguitosInfiniteScrollLoaded) return;
  window.ConguitosInfiniteScrollLoaded = true;

  var loading = false;
  var observer = null;

  function findGrid(root) {
    return root.querySelector("#facet-main .product-list__inner") ||
      root.querySelector("product-list .product-list__inner") ||
      root.querySelector(".product-list__inner");
  }

  function findPagination(root) {
    return root.querySelector("[data-infinite-pagination]") ||
      root.querySelector("page-pagination.pagination") ||
      root.querySelector(".pagination");
  }

  function findNextLink(root) {
    var pagination = findPagination(root);
    return pagination ? pagination.querySelector('a[rel="next"]') : null;
  }

  function getStatusElement() {
    var status = document.querySelector(".infinite-scroll-status");
    var grid = findGrid(document);

    if (!status && grid) {
      status = document.createElement("div");
      status.className = "infinite-scroll-status";
      status.setAttribute("aria-live", "polite");
      grid.insertAdjacentElement("afterend", status);
    }

    return status;
  }

  function setStatus(text) {
    var status = getStatusElement();
    if (status) status.textContent = text || "";
  }

  function buildNextUrl(nextLink) {
    var url = new URL(nextLink.href, window.location.origin);
    var currentUrl = new URL(window.location.href);
    var nextPage = nextLink.getAttribute("data-page");

    currentUrl.searchParams.forEach(function (value, key) {
      if (key !== "page" && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    if (nextPage) {
      url.searchParams.set("page", nextPage);
    }

    return url;
  }

  function forceVisible(item) {
    item.removeAttribute("reveal");
    item.style.opacity = "1";
    item.style.visibility = "visible";
    item.style.transform = "none";

    item.querySelectorAll("[reveal]").forEach(function (child) {
      child.removeAttribute("reveal");
      child.style.opacity = "1";
      child.style.visibility = "visible";
      child.style.transform = "none";
    });

    return item;
  }

  function getGridItems(grid) {
    return Array.from(grid.children).filter(function (item) {
      return item.matches("product-item, .product-item") ||
        item.querySelector("product-item, .product-item") ||
        item.style.gridColumn;
    });
  }

  async function fetchPage(nextUrl, sectionId) {
    var urls = [];

    if (sectionId) {
      var sectionUrl = new URL(nextUrl.toString());
      sectionUrl.searchParams.set("section_id", sectionId);
      urls.push(sectionUrl);
    }

    urls.push(nextUrl);

    for (var i = 0; i < urls.length; i++) {
      var response = await fetch(urls[i].toString(), {
        credentials: "same-origin"
      });

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var grid = findGrid(doc);
      var pagination = findPagination(doc);
      var items = grid ? getGridItems(grid) : [];

      if (items.length) {
        return {
          items: items,
          pagination: pagination,
          url: urls[i].toString()
        };
      }
    }

    return {
      items: [],
      pagination: null,
      url: nextUrl.toString()
    };
  }

  async function loadMoreProducts() {
    if (loading) return;

    var grid = findGrid(document);
    var pagination = findPagination(document);
    var nextLink = findNextLink(document);
    var facet = document.querySelector("product-facet");

    if (!grid) {
      setStatus("No encuentro la parrilla de productos.");
      return;
    }

    if (!pagination || !nextLink) {
      setStatus("");
      if (observer) observer.disconnect();
      return;
    }

    loading = true;
    if (observer) observer.disconnect();

    setStatus("...");

    try {
      var nextUrl = buildNextUrl(nextLink);
      var sectionId = facet ? facet.getAttribute("section-id") : null;
      var result = await fetchPage(nextUrl, sectionId);

      if (!result.items.length) {
        setStatus("");
        console.warn("Infinite scroll sin productos:", result.url);
        return;
      }

      result.items.forEach(function (item) {
        var clone = document.importNode(item, true);
        grid.appendChild(forceVisible(clone));
      });

      if (result.pagination && result.pagination.querySelector('a[rel="next"]')) {
        result.pagination.setAttribute("data-infinite-pagination", "");

        if (pagination) {
          pagination.replaceWith(document.importNode(result.pagination, true));
        }
      } else if (pagination) {
        pagination.remove();
      }

      setStatus("");
      window.dispatchEvent(new Event("resize"));
    } catch (error) {
      setStatus("Error cargando productos. Mira la consola.");
      console.error("Infinite scroll error:", error);
    } finally {
      loading = false;
      setTimeout(initInfiniteScroll, 200);
    }
  }

  function initInfiniteScroll() {
    var grid = findGrid(document);
    var pagination = findPagination(document);
    var nextLink = findNextLink(document);

    if (!grid || !pagination || !nextLink) return;

    pagination.setAttribute("data-infinite-pagination", "");
    document.documentElement.classList.add("infinite-scroll-ready");

    var status = getStatusElement();

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) {
        loadMoreProducts();
      }
    }, {
      rootMargin: "0px 0px 0px 0px",
      threshold: 1
    });

    observer.observe(status);
  }

  document.addEventListener("DOMContentLoaded", initInfiniteScroll);
  document.addEventListener("shopify:section:load", initInfiniteScroll);
})();
(function () {
  const MOBILE_BREAKPOINT = 740;

  // Las bubbles solamente permanecen visibles arriba del todo.
  const TOP_VISIBLE_OFFSET = 50;

  /*
   * Hasta superar 450px mantenemos los filtros.
   * Esto evita cambios bruscos cerca del comienzo de la colección.
   */
  const REVEAL_OFFSET = 450;

  // Ignora rebotes inferiores a 10px.
  const DIRECTION_THRESHOLD = 10;

  let lastDirectionY = Math.max(window.scrollY || 0, 0);
  let currentDirection = '';
  let ticking = false;

  /**
   * Aplica un único estado al body.
   */
  function setMobileStickyState(state) {
    document.body.classList.toggle(
      'mobile-at-top',
      state === 'top'
    );

    document.body.classList.toggle(
      'mobile-scroll-up',
      state === 'up'
    );

    document.body.classList.toggle(
      'mobile-scroll-down',
      state === 'down'
    );
  }

  function collectionHasBubbles() {
  return Boolean(
    document.querySelector(
      '.shopify-section--collectin-filter .bloque_list__item, ' +
      '[id*="collection_button_filter"] .bloque_list__item'
    )
  );
}

  function updateMobileStickyBars() {
    const currentScrollY = Math.max(
      window.scrollY || window.pageYOffset || 0,
      0
    );

    /*
     * En escritorio eliminamos todos los estados móviles.
     */
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      setMobileStickyState('');
      currentDirection = '';
      lastDirectionY = currentScrollY;
      ticking = false;
      return;
    }
    if (!collectionHasBubbles()) {
  setMobileStickyState('down');
  currentDirection = 'down';
  lastDirectionY = currentScrollY;
  ticking = false;
  return;
}

    /*
     * Zona inicial:
     * bubbles visibles en su posición natural.
     */
    if (currentScrollY < TOP_VISIBLE_OFFSET) {
      setMobileStickyState('top');
      currentDirection = '';
      lastDirectionY = currentScrollY;
      ticking = false;
      return;
    }

    /*
     * Entre 50px y 450px:
     * mostramos siempre título + filtros.
     *
     * Esto corrige exactamente lo que aparece en tu captura.
     */
    if (currentScrollY < REVEAL_OFFSET) {
      setMobileStickyState('down');
      currentDirection = 'down';
      lastDirectionY = currentScrollY;
      ticking = false;
      return;
    }

    const distance = currentScrollY - lastDirectionY;

    /*
     * No cambiamos de estado por pequeños movimientos
     * o rebotes táctiles.
     */
    if (Math.abs(distance) < DIRECTION_THRESHOLD) {
      ticking = false;
      return;
    }

    /*
     * Bajando: filtros.
     * Subiendo: bubbles.
     */
    currentDirection = distance > 0 ? 'down' : 'up';
    setMobileStickyState(currentDirection);

    lastDirectionY = currentScrollY;
    ticking = false;
  }

  function requestStickyUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateMobileStickyBars);
  }

  window.addEventListener(
    'scroll',
    requestStickyUpdate,
    { passive: true }
  );

  window.addEventListener('resize', function () {
    lastDirectionY = Math.max(window.scrollY || 0, 0);
    updateMobileStickyBars();
  });

  window.requestAnimationFrame(updateMobileStickyBars);
})();